module.exports = (typeof Array.from === 'function' ?
  Array.from :
  require('./polyfill')
);



//////////////////
// WEBPACK FOOTER
// ./node_modules/array-from/index.js
// module id = 111
// module chunks = 0